import useSWR from "swr";
import useTokenHook from "../context/useTokenHook";
import { fetchItemDiscrepancy } from "../../utils/requests/fetchItemDiscrepancy";

const useItemViewDiscrepancy = (currentItemId: string, linkedBoards: any) => {
  const { token } = useTokenHook();

  const { isLoading, error, data, mutate, isValidating } = useSWR(
    token && currentItemId && linkedBoards ? `itemViewDiscrepancy:${currentItemId}-${linkedBoards}-` : null,
    () => fetchItemDiscrepancy(token!, currentItemId, linkedBoards),
    {
      revalidateOnFocus: false,
      dedupingInterval: 5000,
    }
  );

  return {
    isLoading,
    error,
    data,
    mutate,
    isValidating,
  };
};

export default useItemViewDiscrepancy;
